const e = { last_updated: "Last updated", Series_type: "Series", "How to guide_type": "Guide", FAQ_type: "Default" }, t = {
  articles: e
};
export {
  e as articles,
  t as default
};
//# sourceMappingURL=help-center-knowledge-anatomies17.js.map
